import { IPOSLocation, menuPosApi } from 'components/menu/MenuPosApi';
import { PosLocationsActionTypes } from './posLocationsActionTypes';
import { ActionCreator } from 'redux';

interface IBaseReducerAction {
    type: PosLocationsActionTypes;
}
interface IProgressAction extends IBaseReducerAction {
    type: PosLocationsActionTypes.START_REQUEST | PosLocationsActionTypes.END_REQUEST;
}
interface IErrorAction extends IBaseReducerAction {
    type: PosLocationsActionTypes.LOAD_ERROR;
}
interface ILoadingAction extends IBaseReducerAction {
    type: PosLocationsActionTypes.LOAD_SUCCESS;
    posLocations: IPOSLocation[];
}
interface IResetAction extends IBaseReducerAction {
    type: PosLocationsActionTypes.RESET;
}
export type IPosLocationsAction = IProgressAction | ILoadingAction | IErrorAction | IResetAction;

export function resetPosLocations() {
    return function (dispatch: ActionCreator<IResetAction>) {
        dispatch({
            type: PosLocationsActionTypes.RESET
        });
    };
}

export function getPosLocations() {
    return async function (dispatch: ActionCreator<ILoadingAction | IProgressAction>) {
        dispatch({ type: PosLocationsActionTypes.START_REQUEST });
        try {
            const result = await menuPosApi.getList();
            if (result.ok) {
                dispatch({
                    type: PosLocationsActionTypes.LOAD_SUCCESS,
                    posLocations: result.body.items
                });
            } else {
                dispatch({
                    type: PosLocationsActionTypes.LOAD_ERROR
                });
            }
        } catch (error) {
            dispatch({
                type: PosLocationsActionTypes.LOAD_ERROR,
                message: error.message
            });
        } finally {
            dispatch({ type: PosLocationsActionTypes.END_REQUEST });
        }
    };
}
